module.exports = __webpack_public_path__ + "img/big.e1620b1e.jpg";